/**
 * TODO: Update this component to use your client-side framework's link
 * component. We've provided examples of how to do this for Next.js, Remix, and
 * Inertia.js in the Catalyst documentation:
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

type RouterLinkProps = React.ComponentPropsWithoutRef<typeof RouterLink>;
type CatalystLinkProps = Omit<RouterLinkProps, "to"> & {
  href?: RouterLinkProps["to"];
  to?: RouterLinkProps["to"];
};

export const Link = forwardRef<HTMLAnchorElement, CatalystLinkProps>(
  function Link({ href, to, ...props }, ref) {
    const destination = to ?? href ?? "#";

    return (
      <Headless.DataInteractive>
        <RouterLink {...props} to={destination} ref={ref} />
      </Headless.DataInteractive>
    );
  }
);
